import * as angular from 'angular';
import { config } from 'angular/utils/config';

export interface CreditLimitResource
    extends ng.resource.IResourceClass<ng.resource.IResource<CreditLimitDto>> {
    getCreditLimits: ng.resource.IResourceMethod<
        ng.resource.IResource<CreditLimitDto>
    >;
    createCreditLimit: ng.resource.IResourceMethod<
        ng.resource.IResource<CreditLimitDto>
    >;
    updateCreditLimit: ng.resource.IResourceMethod<
        ng.resource.IResource<CreditLimitDto>
    >;
    deleteCreditLimit: ng.resource.IResourceMethod<void>;
}

function creditLimitResource(
    $resource: ng.resource.IResourceService
): CreditLimitResource {
    return <CreditLimitResource>$resource(
        config.monolithApi + '/credit-limit/',
        {},
        {
            getCreditLimits: {
                method: 'GET',
                url: config.monolithApi + '/credit-limit/',
                isArray: true,
                params: {
                    shipperRefId: '@shipperRefId'
                }
            },
            createCreditLimit: {
                method: 'POST',
                url: config.monolithApi + '/credit-limit/'
            },
            updateCreditLimit: {
                method: 'PUT',
                url: config.monolithApi + '/credit-limit/:id'
            },
            deleteCreditLimit: {
                method: 'DELETE',
                url: config.monolithApi + '/credit-limit/:id'
            }
        }
    );
}

angular.module('app').factory('creditLimitResource', creditLimitResource);
